import React from 'react';
import { Zap, PlayCircle, Clock } from 'lucide-react';

export function Palette() {
  const onDragStart = (event: React.DragEvent, nodeType: string) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside className="w-64 bg-gray-50 border-r p-4 flex flex-col gap-4">
      <div>
        <h3 className="font-semibold text-gray-900 mb-2">Triggers</h3>
        <div 
          className="bg-white border rounded-md p-3 shadow-sm cursor-grab flex items-center gap-2 hover:border-blue-500 hover:text-blue-600 transition-colors"
          onDragStart={(event) => onDragStart(event, 'triggerNode')} 
          draggable
        >
          <div className="bg-blue-100 text-blue-600 p-1.5 rounded">
            <Zap className="h-4 w-4" />
          </div>
          <span className="text-sm font-medium">Event Trigger</span>
        </div>
      </div>

      <div>
        <h3 className="font-semibold text-gray-900 mb-2">Actions</h3>
        <div 
          className="bg-white border rounded-md p-3 shadow-sm cursor-grab flex items-center gap-2 hover:border-blue-500 hover:text-blue-600 transition-colors mb-2"
          onDragStart={(event) => onDragStart(event, 'actionNode')} 
          draggable
        >
          <div className="bg-indigo-100 text-indigo-600 p-1.5 rounded">
            <PlayCircle className="h-4 w-4" />
          </div>
          <span className="text-sm font-medium">Action</span>
        </div>
        
        <div 
          className="bg-white border rounded-md p-3 shadow-sm cursor-grab flex items-center gap-2 hover:border-blue-500 hover:text-blue-600 transition-colors"
          onDragStart={(event) => onDragStart(event, 'delayNode')} 
          draggable
        >
          <div className="bg-orange-100 text-orange-600 p-1.5 rounded">
            <Clock className="h-4 w-4" />
          </div>
          <span className="text-sm font-medium">Delay</span>
        </div>
      </div>
    </aside>
  );
}
